import React from 'react';
import PropTypes from 'prop-types';
import {Grid} from "@material-ui/core";
import {TabBarCrossSelling} from "../../index";
import {SW_CROSS_SELLING_TABS} from "../../../store/types";
import FlightTakeoffIcon from '@material-ui/icons/FlightTakeoff';
// import DeckIcon from '@material-ui/icons/Deck';
import LocalHotelIcon from '@material-ui/icons/LocalHotel';
import DirectionsCarIcon from '@material-ui/icons/DirectionsCar';
import LocalParkingIcon from '@material-ui/icons/LocalParking';
import LandscapeIcon from '@material-ui/icons/Landscape';
import {t} from 'ttag';

const CrossSelling = ({tab, onChange}) => {

    return (
        <Grid spacing={2} container>
            <Grid xs={12} item>
                <TabBarCrossSelling
                    selected={tab}
                    //onSelect={(e, v) => onChange(v)}
                    hideMenuWhenAllTabsVisible
                    tabs={[
                        {
                            label: t`FLIGHT`,
                            icon: <FlightTakeoffIcon color={'secondary'} style={{marginRight: '5px'}}/>,
                            value: SW_CROSS_SELLING_TABS.FLIGHT,
                        },
                        /*{
                            label: t`EXPERIENCES`,
                            icon: <DeckIcon color={'secondary'} style={{marginRight: '5px'}}/>,
                            value: SW_CROSS_SELLING_TABS.EXPERIENCES,
                            href: 'https://azoresgetaways.com/experiences?affiliateCode=azoresairlines',
                            openInNewTab: true,
                        },*/
                        {
                            label: t`HOTEL`,
                            icon: <LocalHotelIcon color={'secondary'} style={{marginRight: '5px'}}/>,
                            value: SW_CROSS_SELLING_TABS.HOTEL,
                            href: 'https://www.booking.com/index.html?aid=363553&label=sata-homepage-sb',
                            openInNewTab: true,
                        },
                        {
                            label: t`CAR`,
                            icon: <DirectionsCarIcon color={'secondary'} style={{marginRight: '5px'}}/>,
                            value: SW_CROSS_SELLING_TABS.CAR,
                            href: 'https://www.rentalcars.com/?affiliateCode=azoresairlines',
                            openInNewTab: true,
                        },
                        {
                            label: t`PARKING`,
                            icon: <LocalParkingIcon color={'secondary'} style={{marginRight: '5px'}}/>,
                            value: SW_CROSS_SELLING_TABS.PARKING,
                            href: 'https://sataazores.parkvia.com',
                            openInNewTab: true,
                        },
                        {
                            label: t`ACTIVITIES`,
                            icon: <LandscapeIcon color={'secondary'} style={{marginRight: '5px'}}/>,
                            value: SW_CROSS_SELLING_TABS.ACTIVITIES,
                            href: 'https://azoresgetaways.com/experiences?affiliateCode=azoresairlines',
                            openInNewTab: true,
                        }
                    ]}
                />
            </Grid>
        </Grid>
    );
};

CrossSelling.propTypes = {
    tab: PropTypes.oneOf(Object.values(SW_CROSS_SELLING_TABS)),
    onChange: PropTypes.func,
};

CrossSelling.defaultProps = {
    onChange: () => null,
};

export default CrossSelling;